import React from 'react';
import styled from '@emotion/styled';
import Button from '@via-profit/ui-kit/Button';

import { LocateIcon, MinusIcon, MoonIcon, PlusIcon, SunIcon } from '../../../assets/icons';
import { MOBILE_QUERY } from '../../layout';

export interface MapControlsProps {
  readonly onZoomIn: () => void;
  readonly onZoomOut: () => void;
  readonly onLocate: () => void;
  readonly dark: boolean;
  readonly onThemeToggle: () => void;
}

const Column = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media ${MOBILE_QUERY} {
    top: auto;
    bottom: 40px;
    right: 8px;
  }
`;

/** Круглая кнопка карты: белая, с тенью, как у Яндекс/Google. */
const RoundButton = styled(Button)`
  width: 44px;
  height: 44px;
  padding: 0;
  border-radius: 50%;
  font-size: 20px;
  background-color: ${({ theme }) => theme.color.surface.toString()};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);

  &:hover:not(:disabled) {
    background-color: ${({ theme }) =>
      (theme.isDark ? theme.color.surface.lighten(8) : theme.color.surface.darken(5)).toString()};
  }
`;

/** Кнопки карты справа: масштаб, где я, тема. */
const MapControls: React.FC<MapControlsProps> = ({ onZoomIn, onZoomOut, onLocate, dark, onThemeToggle }) => (
  <Column>
    <RoundButton type="button" variant="plain" iconOnly title="Приблизить" onClick={onZoomIn}>
      <PlusIcon />
    </RoundButton>
    <RoundButton type="button" variant="plain" iconOnly title="Отдалить" onClick={onZoomOut}>
      <MinusIcon />
    </RoundButton>
    <RoundButton type="button" variant="plain" iconOnly title="Где я" onClick={onLocate}>
      <LocateIcon />
    </RoundButton>
    <RoundButton
      type="button"
      variant="plain"
      iconOnly
      title={dark ? 'Светлая тема' : 'Тёмная тема'}
      onClick={onThemeToggle}
    >
      {dark ? <SunIcon /> : <MoonIcon />}
    </RoundButton>
  </Column>
);

export default MapControls;
